import { render, staticRenderFns } from "./pressalit.vue?vue&type=template&id=232ae225&lang=pug&"
import script from "./pressalit.vue?vue&type=script&lang=js&"
export * from "./pressalit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports